
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./ServicesSection.css";

import {
  Building2,
  Cloud,
  UserCog,
  Users,
  CreditCard,
  HeartPulse,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    icon: Building2,
    title: "Enterprise Solutions",
    description:
      "Scalable and secure solutions designed to streamline your business operations and drive growth with technology.",
  },
  {
    icon: Cloud,
    title: "SaaS Solutions",
    description:
      "Cloud-based SaaS solutions designed to simplify business operations. Access powerful, scalable and secure software applications anytime, anywhere.",
  },
  {
    icon: UserCog,
    title: "IT Consulting",
    description:
      "Expert guidance to help you plan, implement, optimize and scale your technology journey.",
  },
  {
    icon: Users,
    title: "Lead Management System",
    description:
      "Capture, track and convert leads efficiently while managing customers, follow-ups and sales activities.",
    status: "available",
  },
  {
    icon: CreditCard,
    title: "Payment Orchestrator",
    description:
      "Seamless and secure payment integration across multiple platforms for reliable payment processing.",
    status: "coming-soon",
  },
  {
    icon: HeartPulse,
    title: "Healthcare Management System",
    description:
      "Smart healthcare solutions for better patient care, efficient management and smoother operations.",
    status: "coming-soon",
  },
];

const ServicesSection = () => {
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const animatedElements = section.querySelectorAll(
      ".services-header, .service-card"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    animatedElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section className="services-section" ref={sectionRef}>
      <div className="services-container">

        {/* Section Header */}
        <div className="services-header">
          <div className="services-label">
            <span></span>
            <p>OUR EXPERTISE</p>
            <span></span>
          </div>

          <h2>
            Our Core <span>Service &amp; Products</span>
          </h2>

          <p className="services-subtitle">
            Integrated solutions to help businesses grow, innovate and succeed
            in a digital world.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <div
                className="service-card"
                key={service.title}
                style={{
                  "--card-delay": `${index * 0.1}s`,
                }}
              >
                <div className="service-icon">
                  <Icon size={34} strokeWidth={2} />
                </div>

                <h3>{service.title}</h3>

                <div className="service-line"></div>

                <p>{service.description}</p>

                {/* Lead Management Product Button */}
                

{service.status === "available" && (
  <button
    type="button"
    className="product-btn"
    onClick={() => navigate("/products/lead-management")}
  >
    View Product
    <ArrowUpRight size={17} />
  </button>
)}

{service.status === "coming-soon" && (
  <div className="coming-soon-badge">
    <span className="coming-soon-dot"></span>
    Launching Soon
  </div>
)}

              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;
